import breakTo from '../../styles/tools/breakTo'

export default ({ colors, spacings, images }) => {
  const keyframes = {
    opac: {
      '0%': {
        opacity: '0'
      },

      '100%': {
        opacity: '1'
      }
    }
  }

  const styles = {
    modal: {
      position: 'fixed',
      zIndex: '100',

      width: '100%',
      height: '100%',

      '::before': {
        display: 'inline-block',

        height: '100%',

        content: '\'\'',
        verticalAlign: 'middle'
      }
    },

    'modal--hidden': {
      display: 'none',

      animation: `${keyframes.opac} .5s`
    },

    closeBtn: {
      position: 'fixed',
      zIndex: '150',
      top: '0',
      right: '0',

      width: spacings.x4,
      height: spacings.x4,
      marginTop: spacings.x4,
      marginRight: spacings.x4,

      cursor: 'pointer',

      borderRadius: '100%',
      backgroundColor: colors.modal.closeButton,
      backgroundImage: images.closeIcon,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },

    title: {
      margin: '0',

      color: colors.modal.title
    },

    subtitle: {},

    bg: {
      position: 'fixed',
      zIndex: '100',
      top: '0',
      left: '0',

      width: '100%',
      height: '100%',

      opacity: '.97',
      backgroundColor: colors.modal.overlay
    },

    wrapper: {
      display: 'inline-block',

      width: '100%',

      verticalAlign: 'middle'
    },

    content: {
      position: 'relative',
      zIndex: '110',
      right: '0',
      left: '0',

      width: '90vw',
      marginRight: 'auto',
      marginLeft: 'auto',

      borderRadius: '4px',
      backgroundColor: 'transparent',

      [breakTo('small')]: {
        width: '50vw',
        padding: `0 ${spacings.x4}`
      }
    },

    'content--selfie': {
      [breakTo('small')]: {
        width: 'auto',

        textAlign: 'center'
      },

      width: 'auto',

      textAlign: 'center'
    },

    buttons: {
      paddingTop: spacings.x4,
      paddingBottom: spacings.x4,

      textAlign: 'center',

      '> button': {
        marginTop: '0',
        marginBottom: '0'
      }
    }
  }

  return styles
}



// WEBPACK FOOTER //
// ./styles/objects/modal.js